import HeroHeading from '../Headings/HeroHeading'
import HeroDescription from '../Headings/HeroDescription'
import BookACallButton from '../Buttons/Specials/BookACallButton'
import HomepageBookCallLeadModal from '../Modals/HomepageBookCallLeadModal'

const BETTER_DIRECT_MAIL_MODAL_PROPS = {
    formName: 'Better Direct Mail Strategy Call',
}

function HeroSection() {
    return (
        <div className="md:pt-10 pb-10 md:pb-5 md:-mt-20 -mt-12 pt-12 relative border-solid border-t-2">
            <div className="m-auto max-w-full w-[1300px] px-4 xl:px-6 relative flex flex-col-reverse lg:flex-row items-center lg:items-center">
                <div className="w-full lg:w-7/12">
                    <div className="lg:text-left text-center">
                        <p className="bg-[#FFF8E9] text-base text-[#3F454F] px-5 font-semibold rounded-lg max-w-fit mx-auto lg:mx-0">
                            Switch in days, not weeks
                        </p>
                        <div className="m-auto text-center lg:text-left">
                            <HeroHeading>
                                Make the Switch to Open{' '}
                                <br className="hidden lg:block" /> Letter
                                Marketing
                            </HeroHeading>
                        </div>
                        <div className="lg:hidden w-3/4 mx-auto py-4">
                            <img
                                src="/assets/better-direct-mail/better-direct-mail-hero.webp"
                                alt="Floating Postcard design for real estate investors"
                                title="Unique postcard design with standout results"
                                className="m-auto"
                            />
                        </div>
                        <div className="py-5">
                            <h2 className="text-xl font-semibold">
                                Leave behind generic mail houses. Step up to
                                investor-built{' '}
                                <br className="hidden lg:block" /> marketing
                                campaigns that actually move the needle.
                            </h2>
                        </div>

                        <div className="max-w-full bg-cover bg-no-repeat relative md:static lg:w-10/12 lg:space-y-10 lg:pt-4 my-5 lg:my-0">
                            <div className="hidden md:block">
                                <HeroDescription>
                                    We migrate your campaigns, keep your artwork
                                    intact, and give you transparent tracking
                                    with a 5-step quality check—so you stop
                                    babysitting vendors and start growing your
                                    business.
                                </HeroDescription>
                            </div>

                            <div className="grid relative lg:pt-[0px] grid-flow-row lg:grid-flow-col lg:grid-cols-1 gap-4 max-w-fit mx-auto my-3 lg:mx-0 lg:my-0">
                                <div>
                                    <BookACallButton
                                        Modal={HomepageBookCallLeadModal}
                                        modalProps={
                                            BETTER_DIRECT_MAIL_MODAL_PROPS
                                        }>
                                        Book a Free Strategy Call & Claim 15%
                                        OFF Today
                                    </BookACallButton>
                                    <p className="py-3">
                                        Use code SWITCH15 for 15% off your first
                                        order.
                                    </p>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <div className="hidden lg:flex w-full lg:w-5/12 justify-center md:justify-end">
                    <img
                        src="/assets/better-direct-mail/better-direct-mail-hero.webp"
                        alt="Floating Postcard design for real estate investors"
                        title="Unique postcard design with standout results"
                        className=""
                    />
                </div>
            </div>
        </div>
    )
}

export default HeroSection
